import { memo } from 'react';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import PmiTextField from 'shell/components/shared/text-field';

interface IdentityCardProps {
  disabled?: boolean;
  values?: AccordionGeneralityFormVM;
  onChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionGeneralityFormVM>;
  touched?: FormikTouched<AccordionGeneralityFormVM>;
}

const ConsulateReleaseComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid
      container
      item
      xs={12}
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={{ xs: 1, md: 0 }}
    >
      <Grid item xs={12} md={7}>
        <PmiTextField
          label="Ente/Luogo Rilascio"
          aria-label="Ente Luogo Rilascio"
          id="release-location"
          fullWidth
          onChange={(event) => {
            onChange('consulateCode', event?.target.value);
          }}
          inputProps={{
            maxLength: '120',
          }}
          value={values?.consulateCode || ''}
          disabled={isEditMode ? false : disabled}
          helperText={errors?.consulateCode}
          error={touched?.consulateCode && Boolean(errors?.consulateCode)}
        />
      </Grid>
    </Grid>
  );
};

ConsulateReleaseComponent.displayName = 'Consulate Release component';

const ConsulateRelease = memo(ConsulateReleaseComponent);

export default ConsulateRelease;
